<script setup>
import { useI18n } from 'vue-i18n'

// Editorial copy block at the foot of a catalogue root (charters, villas,
// rentals, transfers, experiences — 2026-09-08). Three short paragraphs in
// the site's own voice that say, in plain words, what the page sells and
// where: the text search engines rank on, now that the pages are
// server-rendered. Copy lives under public.seo_copy.<section> in all four
// locales; keep it true to the product, never a keyword list.
const props = defineProps({
  section: { type: String, required: true }, // charters | villas | rentals | transfers | experiences
})
const { t } = useI18n()
const paragraphs = ['p1', 'p2', 'p3']
</script>

<template>
  <section class="seocopy" :aria-labelledby="`seocopy-${props.section}`">
    <div class="seocopy__inner">
      <h2 :id="`seocopy-${props.section}`" class="seocopy__title">{{ t(`public.seo_copy.${props.section}.title`) }}</h2>
      <div class="seocopy__body">
        <p v-for="p in paragraphs" :key="p">{{ t(`public.seo_copy.${props.section}.${p}`) }}</p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.seocopy { padding: clamp(2rem, 4vw, 3.5rem) clamp(1.25rem, 4vw, 3rem) clamp(2.5rem, 5vw, 4rem); border-top: 1px solid color-mix(in oklch, var(--gold) 35%, var(--line)); }
.seocopy__inner { max-width: 96rem; margin: 0 auto; display: grid; grid-template-columns: minmax(0, 18rem) minmax(0, 1fr); gap: 0.75rem 2.5rem; align-items: start; }
.seocopy__title { margin: 0; font-family: var(--display); font-weight: 500; font-size: 1.55rem; line-height: 1.15; color: var(--ink); text-wrap: balance; }
.seocopy__body { display: grid; gap: 0.85rem; max-width: 66ch; color: var(--inkSoft); line-height: 1.6; }
.seocopy__body p { margin: 0; }
@media (max-width: 760px) {
  .seocopy__inner { grid-template-columns: 1fr; }
}
</style>
